<template>
  <v-footer fixed padless absolute>
    <v-fab-transition>
      <v-btn small absolute elevation="15" bottom right fab class="mb-14">
        <WhatsAppButton />
      </v-btn>
    </v-fab-transition>
    <v-card class="flex" flat tile>
      <div class="d-flex justify-center py-1 blue-grey lighten-2">
        <!-- <v-btn class="mx-3" dark icon color="blue">
          <v-icon size="24px"> mdi-facebook </v-icon>
        </v-btn>
        <v-btn class="mx-4" dark icon color="orange darken-1">
          <v-icon size="24px"> mdi-instagram </v-icon>
        </v-btn> -->
        <span
          class="text-center"
          :class="$vuetify.breakpoint.smAndDown ? 'mobileText' : 'text-caption'"
        >
          <div>
            <strong>{{ system.NOME }}</strong>
          </div>
          <div>
            {{
              (system.ENDERECO ?? '') +
              (system.NUMERO ? ', ' + system.NUMERO : '') +
              (system.BAIRRO ? ' - ' + system.BAIRRO : '') +
              (system.CIDADE ? ' / ' + system.CIDADE : '') +
              (system.UF ? ' - ' + (system.UF == 'EX' ? 'PY' : system.UF) : '')
            }}
          </div>
        </span>
      </div>

      <!-- <v-btn @click="showTermsDialog">Termos e Política de Uso</v-btn> -->
      <terms :show="showTerms" @showTermsDialog="showTermsDialog" />
    </v-card>
  </v-footer>
</template>

<script>
import { mapState } from 'vuex'
import WhatsAppButton from './button/WhatsApp-button.vue'
import Terms from './home/Terms.vue'

export default {
  components: { WhatsAppButton, Terms },
  data() {
    return {
      showTerms: false,
    }
  },
  methods: {
    showTermsDialog() {
      this.showTerms = !this.showTerms
    },
  },
  computed: {
    ...mapState('systemModule', ['system']),
  },
}
</script>

<style scoped>
.mobileText {
  font-size: 10px;
}
</style>
